<template>
  <div>
    <div :class="$style.contentWrapper">
      <div :class="$style.title">
        <HgIcon :class="$style.icon" :icon="icon" size="large" theme="secondary" />
        <span>{{ title }}</span>
      </div>
      <img
        :class="$style.img"
        src="@/assets/TenantPlus/listingStats/blurry-image.svg?url"
        alt="Blurred image of a statistic"
        loading="lazy"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { HgIcon, Icon } from '@smg-real-estate/domus';

defineOptions({
  name: 'ListingStatsBlurryItem',
});

interface Props {
  icon: `${Icon}`;
  title: string;
}
defineProps<Props>();
</script>

<style lang="scss" module>
@import '@/assets/variables';

.title {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  opacity: 0.7;
}

.icon {
  margin-right: $space-50;
}

.contentWrapper {
  padding-top: $space-100;
}

.img {
  max-width: 100%;
}

@media (min-width: $viewport-sm-min) {
  .title {
    flex-direction: row;
  }
}
</style>
